<template>
  <div class="profile">
        <div>
            <div class="container">
                <div class="columns">
                    <div class="column is-3">
                        <aside class="menu mt-5 mb-3">
                            <ul class="menu-list">
                                <li>
                                    <router-link :to="{ name: 'doctor.profile' }">{{ $t('doctor_details_label') }}</router-link>
                                </li>
                            </ul>
                            <hr>
                            <p class="menu-label">
                                {{ $t('offices_title') }}
                            </p>
                            <ul class="menu-list">
                                <li v-for="office in offices">
                                    <router-link :to="{ name: 'doctor.profile.office', params: { id: office.id } }" v-text="office.name"></router-link>
                                </li>
                            </ul>
                            <router-link :to="{ name: 'doctor.profile.newOffice' }" class="button is-outlined is-primary mt-3 has-icon">
                                <b-icon icon="plus-circle"></b-icon>
                                <span>{{ $t('add_another_office_button_label') }}</span>
                            </router-link>
                        </aside>
                        <onboarding></onboarding>
                    </div>
                    <div class="column is-7">
                        <div class="box mt-5">
                            <router-view></router-view>
                        </div>
                    </div>
                </div>
            </div>
        </div>
  </div>
</template>

<script>
import helpers from '@/mixins/helpers'

import Advertisements from '@/components/Doctor/Advertisements.vue'
import Onboarding from '@/components/Doctor/Onboarding.vue'

export default {
    name: 'profile',

    components: { Advertisements, Onboarding },

    mixins: [helpers]
}
</script>



// WEBPACK FOOTER //
// src/components/Doctor/Profile.vue